<template>
<div class="spacer">
    <div class="miniplayer" v-show="playingTrack" name="fadein">
        <audio ref="player" :src="source" controls autoplay crossorigin="use-credentials" @play="onPlayerPlay" @pause="onPlayerPause">
        </audio>
      <div id="audioplayer2" class="ddl col-md-1 col-sm-1 col-xs-1" v-if="source">
        <a   :href="source" ><i class="fa fa-download " aria-hidden="true"></i> </a>
      </div>
        <span class="meta" v-if="playingTrack">
            <div class="title">
                {{playingTrack.title||'[No Title]'}} 
            </div>
            <div class="by" v-if="playingTrack.artist">by {{ playingTrack.artist }}</div>
        </span>
  
    </div>
    </div>
</template>
<style scoped>
.spacer {
    flex-grow:1;
}
    .miniplayer{
        display:flex;
        align-items:center;
        height:50px;
        padding:0 10px;
        background:white;
        border:1px solid var(--COLOR_BRAND);
        overflow: hidden;
    }
    audio {
        min-width: 450px;
    }
    .miniplayer .meta{
        flex-grow: 1;
        margin: 0 10px;
        max-width: 290px;
    }
    .title{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color:var(--COLOR_BRAND)
    }
    .by {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;    
        font-size:12px;
        font-weight:600;
        color: #D2D2D2;
    }
</style>
<script>
import Apis from '@/apis/index'
import TrackApis from '@/apis/_apiTracks'
import store from '@/store/index'
import PlayButton from '@/components/common/PlayButton'
//============================================================================================================
import {mapState, mapMutations} from 'vuex'
import EventBus from '@/eventbus/index'
import { HTTP } from '@/utils/http'
//============================================================================================================
export default {
    name:"MiniPlayer",
    components:{PlayButton},
    mounted(){
        EventBus.$on("playTrack", this.onTrackPlay);
        EventBus.$on("stopTrack", this.onTrackPause);
    },
    data(){
        return {
            playToken:null,
        } 
    },
    watch:{
        '$route.params.stationUid':function()  { this.$refs["player"].src = null;this.onResetPlayer(); }
    },
    computed:{
        ...mapState('tracks', ['playingTrack']),
        source() {
             if (this.playingTrack){
                 return TrackApis.getPlayUrl(this.$route.params.stationUid, this.playingTrack.uid, this.playToken);
             }
            return null;
        },
    },
    methods:{
        ...mapMutations('tracks', ["onPlayTrack","onPauseTrack",'onResetPlayer']),
        async onTrackPlay(track){
            console.log("On track Play",track)
            var response = await HTTP.post(Apis.library.tracks.playToken)
            if (response.data){
                if (this.playingTrack !=null && this.playingTrack.uid == track.uid)
                {
                    this.$refs["player"].play();
                }
                else
                {
                    this.playToken = response.data.dataItem.token;
                    this.$refs["player"].src = this.source;
                }
                this.onPlayTrack(track);
            }
        },
        onPlayerPlay(){
            console.log("Player Play" , this.playingTrack)
            this.onPlayTrack(this.playingTrack);
        },
        onPlayerPause(){
            console.log("Player Pause")
            this.onPauseTrack();
        },
        onTrackPause(){
            console.log("Track Pause")
            this.onPauseTrack();
            this.$refs["player"].pause();
        }
    }
}
</script>
<style>
a{
  padding-right: 40px;
  color:black;

}
.fa-download{
  font-size: 20px;
}
</style>
